import { ENGLISH_LANG } from "constants";
import { atom } from "jotai";

const savedLanguage = localStorage.getItem("lang");

export const languageAtom = atom(savedLanguage || ENGLISH_LANG);
